import { useCharlieUser } from 'hooks/useCharlieUser'
import { insightsExperienceViewedEvent } from 'utils/analytics/amplitudeEvents'

import { ClipStar } from './assets/icons/ClipStar'
import { useMenuGroupExperience } from './hooks/useMenuGroupExperience'
import { MenuGroup } from './MenuGroup'

export const MenuGroupExperience = () => {
  const { sidebarItems: sidebarExperienceItems } = useMenuGroupExperience()
  const charlieUser = useCharlieUser()

  if (!sidebarExperienceItems) {
    return null
  }

  return (
    <MenuGroup
      key={sidebarExperienceItems?.text}
      {...sidebarExperienceItems}
      icon={<ClipStar />}
      onClick={() =>
        insightsExperienceViewedEvent(
          { topic: sidebarExperienceItems.text },
          charlieUser
        )
      }
    />
  )
}
